import React from 'react';
import { Sparkles } from './icons';
import { cx, Tooltip } from './ui';

/**
 * Opens the platform HTS classifier in a separate tab so the current Import
 * Hub product remains available for reference.
 */
export const ClassificationLink: React.FC<{
  productId?: string;
  hub?: 'import' | 'export';
  compact?: boolean;
  onClick?: () => void;
}> = ({ productId: _productId, hub: _hub, compact = false, onClick }) => {
  return (
    <Tooltip content='Open HTS Classification in a new tab.'>
      <a
        href='/bite-classify'
        target='_blank'
        rel='noopener noreferrer'
        className={cx(
          'ih-btn',
          'ih-btn-outline',
          compact ? 'ih-btn-sm' : undefined,
        )}
        onClick={onClick}
      >
        <Sparkles size={14} /> Classify with BITE
      </a>
    </Tooltip>
  );
};
